import React__default from "react";
import { RouterContext } from "./router-context.mjs";
const useRouter = ({ onClick } = {}) => {
  const { navigate: routerNavigate } = React__default.useContext(RouterContext);
  const navigate = React__default.useCallback(
    (e) => {
      onClick == null ? void 0 : onClick(e);
      const link = e.target instanceof Element ? e.target.closest("a") : (
        /* istanbul ignore next */
        null
      );
      if (link && link instanceof HTMLAnchorElement && link.getAttribute("href") && (!link.target || link.target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && e.button === 0 && // left clicks only
      !e.metaKey && // open in new tab (mac)
      !e.ctrlKey && // open in new tab (windows)
      !e.altKey && // download
      !e.shiftKey && !e.defaultPrevented) {
        routerNavigate(e);
      }
    },
    [onClick, routerNavigate]
  );
  return React__default.useMemo(
    () => ({
      navigate
    }),
    [navigate]
  );
};
export {
  useRouter
};
